<section #menu id="menu-container" [class.hidden-menu]="!display">
  <section
    id="vertical-line-blue"
    [style.background-color]="
      systemService.configuracao()?.corPredominante
    "></section>
  <section class="container-items">
    <app-menu-tree [data]="items"></app-menu-tree>
  </section>

  <div class="logos-container">
    <a
      href="https://oportunidades.certificaminas.com/confear"
      target="_blank"
      *ngIf="systemService.configuracao()?.exibeCompraCertificadoDigital">
      <img
        id="logo-certificate"
        src="assets/certificado-digital.png"
        alt="certificado digital" />
    </a>
    <div class="logo-egtec-container" *ngIf="systemService.isConfear()">
      <span>Desenvolvido por</span>
      <img
        src="assets/logos/confear/logo-egtec.png"
        alt="certificado digital" />
    </div>
  </div>
</section>
